import type { Grapheme, GraphemeType } from '../../types/content'
import { mappingSeedById } from './concepts'

const alphabet = 'abcdefghijklmnopqrstuvwxyz'.split('')

const derived = new Map<string, { display: string; type: GraphemeType; phonemeIds: Set<string> }>()
for (const mapping of mappingSeedById.values()) {
  const existing = derived.get(mapping.graphemeId)
  if (existing) {
    mapping.phonemeIds.forEach((id) => existing.phonemeIds.add(id))
  } else {
    derived.set(mapping.graphemeId, {
      display: mapping.display,
      type: mapping.graphemeType,
      phonemeIds: new Set(mapping.phonemeIds),
    })
  }
}

for (const letter of alphabet) {
  const id = `grapheme_${letter}`
  if (!derived.has(id)) derived.set(id, { display: letter, type: 'single_letter', phonemeIds: new Set() })
}

export const graphemes: Grapheme[] = [...derived.entries()].map(([id, data]) => ({
  id,
  display: data.display,
  type: data.type,
  phonemeIds: [...data.phonemeIds],
  notes: id === 'grapheme_q' ? 'Letter q is introduced through the teaching unit qu; no standalone core mapping is asserted.' : undefined,
}))

export const graphemeById = new Map(graphemes.map((grapheme) => [grapheme.id, grapheme]))

export interface LetterNameRecord {
  letter: string
  ipa: string
  audioId: string
  path: string
}

const letterNameIpa: Record<string, string> = {
  a: '/eɪ/', b: '/bi/', c: '/si/', d: '/di/', e: '/i/', f: '/ɛf/', g: '/dʒi/', h: '/eɪtʃ/', i: '/aɪ/',
  j: '/dʒeɪ/', k: '/keɪ/', l: '/ɛl/', m: '/ɛm/', n: '/ɛn/', o: '/oʊ/', p: '/pi/', q: '/kju/', r: '/ɑɹ/',
  s: '/ɛs/', t: '/ti/', u: '/ju/', v: '/vi/', w: '/ˈdʌbəlju/', x: '/ɛks/', y: '/waɪ/', z: '/zi/',
}

export const letterNames: LetterNameRecord[] = alphabet.map((letter) => ({
  letter,
  ipa: letterNameIpa[letter],
  audioId: `letter_name_${letter}_ga`,
  path: `/audio/letter-names/en-US/${letter}.wav`,
}))
